{
  "app-version": "Streamplace v{$version}",
  "download-new-update": "Download New Update",
  "check-for-updates": "Check for Updates",
  "bundled-runtype": "Bundled",
  "ota-runtype": "Over-the-Air (OTA)",
  "recovery-runtype": "Recovery Mode",
  "modal-latest-version": "You are using the latest version.",
  "modal-no-update-available": "You are on the latest version of Streamplace, hooray!",
  "modal-update-available-title": "Update Available",
  "modal-update-available-description": "A new version of Streamplace is ready to download",
  "modal-update-failed": "Update check failed. You may need to update the app through the {$store}.",
  "modal-update-failed-title": "Update Failed",
  "modal-update-failed-description": "Update check failed. You may need to update the app through the {$store}.",
  "button-reload-app-on-update": "Apply Update (will reload app)",
  "use-custom-node": "Use Custom Node",
  "default-url": "Default: {$url}",
  "enter-custom-node-url": "Enter custom node URL",
  "save-button": "Save",
  "try-new-web": "Try the new web (beta)",
  "try-new-web-description": "Switch to the new web interface. You can switch back anytime from this same setting.",
  "try-old-app": "Use the original interface",
  "try-old-app-description": "Go back to the original Streamplace interface.",
  "language-selection": "Language",
  "language-selection-description": "Choose your preferred language",
  "input-search-languages": "Search languages...",
  "help-translate": "Help us translate Streamplace",
  "help-translate-description": "We're looking for volunteers to help translate Streamplace into more languages. If you're interested, please reach out to us on Discord or GitHub!",
  "currently-translating": "Translations are on the way",
  "currently-translating-description": "Some parts of the app may look incomplete. Thank you for your patience!",
  "debug-recording-title": "Allow {$host} to record your livestream for debugging and improving the service",
  "debug-recording-description": "Optional",
  "livestream-recording-title": "Record my livestreams into VODs on {$host}",
  "livestream-recording-description": "When enabled, your livestreams are saved so you can finalize and publish them as videos",
  "auto-publish-vods-title": "Publish my livestreams as VODs automatically",
  "auto-publish-vods-description": "When a recorded livestream ends, {$host} publishes it as a video right away, without waiting for you to finalize it",
  "auto-publish-vods-stream-label": "Publish VOD automatically",
  "auto-publish-vods-stream-description": "Publish recorded streams as VODs automatically. Applies to future streams too, until you turn it off.",
  "manage-keys": "Manage Keys",
  "settings-title": "Settings",
  "error": "Error",
  "about": "About",
  "account": "Account",
  "advanced": "Advanced",
  "danmu": "Danmu",
  "developer": "Developer",
  "languages": "Languages",
  "privacy-security": "Privacy & Security",
  "streaming": "Streaming",
  "notifications": "Notifications",
  "notifications-title": "Push Notifications",
  "notifications-web-description": "Get notified when streamers you follow go live.",
  "notifications-mobile-description": "Push notifications are managed by your device settings.",
  "notifications-blocked-description": "Blocked — you denied notification permission in your browser.",
  "notifications-blocked-help": "To re-enable, update site permissions in your browser settings, then toggle this on again.",
  "cancel": "Cancel",
  "create": "Create",
  "delete": "Delete",
  "refresh": "Refresh",
  "sign-in": "Sign In",
  "update": "Update",
  "log-out": "Log out",
  "optional": "optional",
  "account-greeting": "Hey, @{$handle}.",
  "edit-profile-bluesky": "Edit profile (on {$network})",
  "change-name-color": "Change name color",
  "key-management": "Key Management",
  "key-manager": "Key Manager",
  "your-stream-pubkeys": "Your Stream Public Keys",
  "no-keys": "No keys configured",
  "pubkey-description": "Public keys are paired with stream keys (used in streaming software) to sign and verify your stream",
  "keys-count": "{$count ->\n   [one] {$count} key\n   *[other] {$count} keys\n  }",
  "backup": "Backup",
  "backup-enabled": "S3 Backup",
  "backup-enabled-description": "Automatically backup recordings to S3-compatible storage",
  "backup-connection-url": "Connection URL",
  "backup-connection-url-placeholder": "Must be a valid S3 URL in the format s3+https://ACCESS_KEY:SECRET_KEY@region.endpoi.nt/bucket",
  "backup-endpoint": "Endpoint",
  "backup-endpoint-placeholder": "s3.example.com",
  "backup-bucket": "Bucket",
  "backup-bucket-placeholder": "my-backup-bucket",
  "backup-access-key": "Access Key",
  "backup-access-key-placeholder": "AKIAIOSFODNN7EXAMPLE",
  "backup-secret-key": "Secret Key",
  "backup-secret-key-placeholder": "wJalrXUtnFEMI/K7MDENG/bPxRfiCYEXAMPLEKEY",
  "backup-region": "Region",
  "backup-region-placeholder": "us-east-1",
  "backup-test-connection": "Test Connection",
  "backup-testing-connection": "Testing connection...",
  "backup-connection-successful": "Connection successful",
  "backup-connection-failed": "Failed to connect",
  "show-password-in-url": "Show password in URL",
  "show-password-in-url-description": "Display the secret key in the connection URL (if input)",
  "requested-seconds-per-segment": "Seconds per segment",
  "requested-seconds-per-segment-description": "Set the seconds per segment you wish to request the server use",
  "recommendations": "Recommendations",
  "manage-recommendations": "Manage Recommendations",
  "recommendations-to-others": "Recommendations",
  "recommendations-description": "Share up to 8 streamers you recommend to your viewers",
  "no-recommendations-yet": "No recommendations configured yet",
  "add-recommendation": "Add Recommendation",
  "streamer-did": "Streamer DID",
  "recommendations-count": "{$count ->\n   [one] {$count} recommendation\n   *[other] {$count} recommendations\n  }",
  "webhooks": "Webhooks",
  "webhook-integrations": "Webhook Integrations",
  "webhook-integrations-description": "Connect external services to receive real-time updates about your streams",
  "create-webhook": "Create Webhook",
  "edit-webhook": "Edit Webhook",
  "delete-webhook": "Delete Webhook",
  "no-webhooks-yet": "No webhooks configured yet",
  "failed-load-webhooks": "Failed to load webhooks",
  "webhook-will-no-longer-receive-events": "This webhook will no longer receive events",
  "create-first-webhook-description": "Create your first webhook to start receiving stream events",
  "example-captain-hook": "Captain Hook",
  "webhooks-count": "{$count ->\n   [one] {$count} webhook\n   *[other] {$count} webhooks\n  }",
  "activates-on": "Activates on:",
  "events": "Events",
  "events-livestream": "Livestream Events",
  "events-chat": "Chat Events",
  "events-stream-received": "Stream Received Events",
  "untitled-webhook": "Untitled Webhook",
  "inactive": "Inactive",
  "active": "Active",
  "multistream": "Multistreaming",
  "multistream-targets": "Multistream Targets",
  "multistream-description": "Automatically push your Streamplace livestreams to other streaming services like Twitch or YouTube.",
  "create-multistream-target": "Create Multistream Target",
  "untitled-multistream-target": "Untitled Target",
  "failed-load-multistream-targets": "Failed to load multistream targets. Please try again.",
  "failed-toggle-multistream-target": "Failed to toggle multistream target. Please try again.",
  "failed-delete-multistream-target": "Failed to delete multistream target. Please try again.",
  "no-multistream-targets-yet": "No targets yet!",
  "no-multistream-destinations": "No multistream destinations yet",
  "multistream-targets-count": "{$count ->\n   [one] {$count} target\n   *[other] {$count} targets\n  }",
  "multistream-delete-target-confirmation": "Are you sure you want to delete \"{$target}\"?",
  "this-action-cannot-be-undone": "This action cannot be undone.",
  "rtmp-target-name": "RTMP Target",
  "rtmp-target-url": "RTMP URL",
  "rtmp-target-name-placeholder": "My Multistream Target",
  "multistream-create-target": "Create Target",
  "multistream-edit-target": "Edit Target",
  "created": "created",
  "status": "status",
  "debug-recording": "Debug Recording",
  "danmu-enabled": "Enable Danmu",
  "danmu-enabled-description": "Display live chat messages as floating comments on your screen",
  "danmu-opacity": "Opacity",
  "danmu-speed": "Speed",
  "danmu-lane-count": "Lane Count",
  "danmu-max-messages": "Max Messages",
  "app-version-description": "No updates are available at this time",
  "confirm-delete": "Are you sure you want to delete this?",
  "action-cannot-be-undone": "This action cannot be undone",
  "name-optional": "Name (optional)",
  "deleting": "Deleting...",
  "saving": "Saving...",
  "go-to-dashboard": "Go to Dashboard",
  "need-setup-live-dashboard": "Need to set up streaming first? Visit the live dashboard",
  "no-languages-found": "No languages found",
  "branding": "Branding",
  "branding-admin": "Branding Administration",
  "branding-admin-description": "Customize your Streamplace instance. Note that settings may take a few hours to propagate.",
  "branding-login-required": "Please log in to manage branding",
  "branding-configuration": "Configuration",
  "branding-text-settings": "Text Settings",
  "branding-colors": "Colors",
  "branding-legal-links": "Legal Links",
  "branding-bundle": "Export and import",
  "branding-bundle-description": "A bundle is a zip with branding.yaml (everything set here, with the defaults listed for reference) plus the image files. Edit the YAML by hand or import it on another node.",
  "branding-bundle-export": "Download bundle",
  "branding-bundle-import": "Import bundle…",
  "branding-bundle-merge": "Merge: keep settings the bundle doesn't mention (otherwise they are removed)",
  "branding-bundle-preview": "Changes from {$name}",
  "branding-bundle-no-changes": "Nothing would change.",
  "branding-bundle-apply": "Apply",
  "branding-bundle-imported": "Branding imported ({$count} keys)",
  "branding-bundle-import-failed": "Import failed",
  "branding-bundle-export-failed": "Export failed",
  "branding-bundle-invalid": "That bundle can't be imported",
  "branding-layout": "Layout",
  "branding-app-layout": "App layout",
  "branding-app-layout-description": "Classic is the Streamplace chrome: top bar, brand lockup in the sidebar. Social imitates a timeline app: no top bar, your avatar at the top of the navigation rail, a fixed-width feed column, the social app's navigation icons and 19px white labels. Social implies the Card stream layout.",
  "branding-app-layout-social": "Social",
  "branding-stream-layout": "Stream page layout",
  "branding-stream-layout-description": "Classic is the full-width player with chat beside it. Card shows the stream as a post in a feed column with live chat alongside, the way a social timeline presents a video.",
  "branding-layout-classic": "Classic",
  "branding-layout-card": "Card",
  "branding-typeface": "Typeface",
  "branding-typeface-description": "The sans-serif used across the app. Monospace stays Geist Mono.",
  "branding-chat-layout": "Chat message layout",
  "branding-chat-layout-description": "Compact is one line per message with the time and handle. Avatar shows each message as a post: avatar, display name, handle and age above the text.",
  "branding-chat-compact": "Compact",
  "branding-chat-avatar": "Avatar",
  "branding-chat-name-colors": "Chat name colors",
  "branding-chat-name-colors-description": "Show display names in each user's chosen chat color, or in the default text color.",
  "branding-chat-name-colors-on": "User colors",
  "branding-chat-name-colors-off": "Default color",
  "branding-chat-badges": "Chat badges",
  "branding-chat-badges-description": "Badges beside names in chat. All shows everything; Custom only shows badges issued from your badge definitions and hides the built-in streamer, moderator and bot marks; None hides every badge. Verified checks are separate.",
  "branding-chat-badges-all": "All",
  "branding-chat-badges-custom": "Custom only",
  "branding-chat-badges-none": "None",
  "branding-nav-links": "Navigation links",
  "branding-nav-links-description": "Replace the sidebar's browse and creator sections with your own links: a JSON list of objects with label, url and an optional icon (home, search, play, live, bell, message, hash, list, bookmark, user, settings, video, book). Paths starting with / navigate inside the app; other URLs open as links.",
  "branding-nav-cta": "Navigation button",
  "branding-nav-cta-description": "A highlighted button under the navigation links: JSON with label and url.",
  "branding-app-banner": "Mobile app suggestion",
  "branding-app-banner-description": "On phones, the web app suggests the Streamplace mobile app: a banner in the page and, on iOS, the App Store's Smart App Banner. Turn it off for a node that is its own product.",
  "branding-app-banner-on": "Suggest the app",
  "branding-app-banner-off": "Off",
  "branding-external-links": "External links",
  "branding-external-links-description": "Where the sidebar's links to other sites open on the web: navigation links, the highlighted button, bottom links and the social row.",
  "branding-external-links-new-tab": "New tab",
  "branding-external-links-same-window": "Same window",
  "branding-download-link": "Download link",
  "branding-download-link-description": "The app Download row in the sidebar. Default shows it in the Classic layout and hides it in Social.",
  "branding-download-default": "Default",
  "branding-download-on": "Shown",
  "branding-download-off": "Hidden",
  "branding-bottom-links": "Bottom links",
  "branding-bottom-links-description": "Links pinned above the social row at the bottom of the sidebar, as a JSON list of objects with label, url and icon. Unset shows the Documentation link in the Classic layout and nothing in Social; Hide removes them.",
  "branding-social-links": "Social links",
  "branding-social-links-description": "The row of icon links at the bottom of the sidebar. The first field is its heading; the second is a JSON list of objects with label, url and icon, where icon is bluesky, discord, one of the navigation icon names, or socialIcon1 to socialIcon4 for an uploaded icon. Unset shows the Streamplace links; Hide removes the row.",
  "branding-social-heading-placeholder": "Say Hello?",
  "branding-social-hide": "Hide",
  "branding-upload": "Upload",
  "branding-remove": "Remove",
  "branding-social-icons-description": "Uploaded icons, referenced from the list above by slot name. SVG preferred, 24 x 24, max 64KB; an SVG drawn with currentColor takes the sidebar's icon color.",
  "branding-theme": "Theme",
  "branding-theme-description": "Page background and text color, one pair per color scheme; the app derives its raised surfaces, muted text and hairline borders from them. Hex colors (#rrggbb). Accent and status colors are separate settings above. Leave a value unset to use the default, or set only the background and the text color is chosen to read on it.",
  "branding-background-dark": "Page background (dark mode)",
  "branding-foreground-dark": "Text color (dark mode)",
  "branding-background-light": "Page background (light mode)",
  "branding-foreground-light": "Text color (light mode)",
  "branding-reset": "Reset",
  "branding-default": "default",
  "branding-status-colors": "Status Colors",
  "branding-status-colors-description": "Colors for errors, success, warnings, informational notes and the live badge. Hex colors (#rrggbb); text on top of them is chosen automatically.",
  "branding-danger-color": "Danger / error",
  "branding-success-color": "Success",
  "branding-warning-color": "Warning",
  "branding-info-color": "Info",
  "branding-live-color": "Live badge",
  "branding-images": "Images",
  "branding-broadcaster-did": "Broadcaster DID",
  "branding-broadcaster-did-description": "Leave empty to use server default",
  "branding-site-title": "Site Title",
  "branding-site-title-placeholder": "Enter new site title",
  "branding-site-description": "Site Description",
  "branding-site-description-placeholder": "Enter site description",
  "branding-link-cards": "Link cards",
  "branding-link-cards-description": "What a shared link shows for each page: the stream page, the front page (live tab), the videos tab, a video page and the go-live tab. Templates take {} (the site name below, or the site title), and on pages about one account {} (their display name, else handle) and {}. Descriptions of stream and video pages are their post text.",
  "branding-network-name": "Network name",
  "branding-network-name-description": "What the app calls the social network viewers sign in with and share to: \"Sign in with your {$network} account\", \"Share to {$network}\", the live-ring permission. Default Bluesky.",
  "branding-network-profile-url": "Profile link",
  "branding-network-profile-url-description": "Where a chat user's profile link goes, from the profile card and the message menu. Use {} and {} as placeholders. Default is the Bluesky profile page.",
  "branding-network-icon-description": "Icon shown on those profile links. SVG preferred, max 64KB; unset shows the Bluesky butterfly.",
  "branding-verifiers": "Verified users",
  "branding-verifiers-description": "DIDs of the verifiers this node trusts, as a JSON list. Anyone they have issued an app.bsky.graph.verification record for shows a verified badge in chat. Bluesky's own verification shows its blue check regardless.",
  "branding-labeler-description": "Or a labeler and the label values that mean verified on your network: the labeler's DID, then the labels, comma-separated, with a trailing * for a prefix (e.g. verified-*). Accounts carrying one of those labels count as verified here, next to any verifiers above.",
  "branding-verify-appview-description": "Or an app view whose getProfile carries your network's own verification field: its URL, the field name (default wsocialVerified) and the values that count, comma-separated, or * for any value. The node asks it about each chat author on first sight and re-checks every few minutes.",
  "branding-verify-bluesky-description": "Also count Bluesky's blue check: accounts Bluesky's public app view reports as verified can chat here too, and wear Bluesky's check rather than your badge.",
  "branding-verify-bluesky-off": "Your verifiers only",
  "branding-verify-bluesky-on": "Plus Bluesky's blue check",
  "branding-quick-login-return-description": "Appended to the identity app's sign-in link on phones as ?return=<value>, so the app knows where to send people back. Leave empty to append nothing.",
  "branding-verify-url-description": "Where a signed-in but unverified user goes to get verified: the \"Verify now\" link under the composer when chat is verified-only. Unset shows no link.",
  "branding-verified-only-message-description": "What the composer says when chat is verified-only and the viewer can't write, and the label of the verify link beside it. Signed-out viewers get a sign-in link instead.",
  "branding-sign-in-buttons-description": "The signed-out composer's two sign-in buttons (PDS login mode): the network button's label, the small line under it, and the OAuth button's label (also shown on the sign-in form). Defaults use the network name.",
  "branding-non-member-description": "For a signed-in viewer whose account isn't on your network's PDS (the login PDS above): the message, the page where they can apply for an account, and the link's label.",
  "branding-chat-verified-only-description": "Restrict chat to users verified by those verifiers. Others see a notice instead of the composer and their messages are not shown.",
  "branding-chat-verified-only-off": "Anyone can chat",
  "branding-chat-verified-only-on": "Verified only",
  "branding-verified-icon-description": "Badge shown beside verified users. SVG preferred, max 64KB, currentColor takes the primary color; unset shows a check in the primary color.",
  "branding-login-mode": "Sign-in",
  "branding-login-mode-description": "How viewers sign in. OAuth is the node's own flow. PDS signs in directly against a PDS with email (or handle) and password, an app password works too, plus its QR / app login when enabled; the node then sees the viewer as anonymous.",
  "branding-login-mode-oauth": "OAuth",
  "branding-login-mode-pds": "PDS",
  "branding-login-pds-url-description": "The PDS the sign-in talks to.",
  "branding-quick-login-description": "Offer the PDS's QR / app login beside the password form (the eu.wsocial.quicklogin methods).",
  "branding-quick-login-off": "Off",
  "branding-quick-login-on": "On",
  "branding-login-links-description": "Links on the sign-in screen: forgot password, the waitlist for people without an account, and a support address. Each is hidden when unset.",
  "branding-session-broker": "Session broker",
  "branding-session-broker-description": "Origin of the main app whose /session-broker route hands this site the viewer's existing login, so someone signed in there is signed in here (web only). Leave unset to require a sign-in here.",
  "branding-login-placeholder": "Login handle example",
  "branding-login-placeholder-description": "The example handle shown in the login form's empty handle field, e.g. you.example.com.",
  "branding-default-streamer": "Default Streamer",
  "branding-default-streamer-none": "None",
  "branding-default-streamer-placeholder": "did:plc:...",
  "branding-default-video": "Default video",
  "branding-default-video-description": "While set, the front page shows this video instead of the default streamer's stream: the replay to send everyone to after an event. Its at:// URI, or its page path (handle/video/rkey). Clear it to return the front page to the streamer.",
  "branding-default-video-placeholder": "at://did:plc:.../place.stream.video/... or handle/video/rkey",
  "branding-clear-default-video": "Clear default video",
  "branding-clear-default-streamer": "Clear Default Streamer",
  "branding-primary-color": "Primary Color",
  "branding-primary-color-placeholder": "#6366f1",
  "branding-accent-color": "Accent Color (secondary surfaces, highlights)",
  "branding-accent-color-placeholder": "#8b5cf6",
  "branding-main-logo": "Main Logo",
  "branding-main-logo-description": "SVG, PNG, or JPEG (max 500KB)",
  "branding-favicon": "Favicon",
  "branding-favicon-description": "SVG, PNG, or ICO (max 100KB)",
  "branding-sidebar-bg": "Sidebar Background Image",
  "branding-sidebar-bg-description": "SVG, PNG, or JPEG (max 500kb) - appears aligned to bottom of sidebar, full width. Upload an image with opacity for best results, as there is not currently a separate opacity option.",
  "branding-current": "Current: {$value}",
  "branding-dimensions": "{$height} x {$width}",
  "branding-upload-logo": "Upload Logo",
  "branding-delete-logo": "Delete Logo",
  "branding-upload-favicon": "Upload Favicon",
  "branding-delete-favicon": "Delete Favicon",
  "branding-upload-background": "Upload Background",
  "branding-offline": "Nobody streaming",
  "branding-offline-description": "What the front page shows when no one is live: the illustration (also the thumbnail of a video without one; default the jellyfish) and the two lines beside it.",
  "branding-upload-offline-image": "Upload Illustration",
  "branding-delete-offline-image": "Delete Illustration",
  "branding-go-live-denied": "Go live, denied",
  "branding-go-live-denied-description": "What the Go live page says to a viewer this node does not let stream (the streamer role is gated): a heading and a line, followed by the \"apply for access\" link from the network settings when one is set.",
  "branding-link-banner": "Link Preview Image",
  "branding-link-banner-description": "The image shown when the site's link is shared (OpenGraph / Twitter card). PNG, JPEG or WebP, 1200 x 630 recommended, max 2MB. The card's title and description come from the Site Title and Site Description above.",
  "branding-upload-link-banner": "Upload Image",
  "branding-delete-link-banner": "Remove Image",
  "branding-delete-background": "Delete Background",
  "branding-web-only": "Image uploads are only available on web.",
  "refresh-branding": "Refresh branding assets",
  "branding-add-legal-link": "Add Legal Link",
  "branding-edit-legal-link": "Edit Legal Link",
  "branding-legal-link-text-placeholder": "Link text (e.g., Privacy Policy)",
  "branding-legal-link-url-placeholder": "URL (e.g., https://example.com/privacy)",
  "add": "Add",
  "edit": "Edit",
  "branding-not-authenticated": "Please log in first",
  "branding-empty-value": "Please enter a value",
  "branding-update-success": "{$key} updated successfully",
  "branding-upload-success": "{$key} uploaded successfully",
  "branding-delete-success": "{$key} deleted successfully",
  "branding-upload-failed": "Failed to upload",
  "branding-delete-failed": "Failed to delete",
  "branding-not-available": "File uploads are only available on web",
  "access": "Access",
  "access-admin": "Access Control",
  "access-admin-description": "Decide who can use this node. Admins always hold every role.",
  "access-admin-required": "You need to be signed in as an administrator of this node to manage access.",
  "access-policy": "Policy",
  "access-grants": "Grants",
  "access-role-admin": "Admin",
  "access-role-viewer": "Viewer",
  "access-role-viewer-description": "Use the frontend and watch streams when this node is private",
  "access-role-streamer": "Streamer",
  "access-role-streamer-description": "Go live and send video to this node",
  "access-role-syndicate": "Syndicate",
  "access-role-syndicate-description": "Media carried over from other nodes",
  "access-role-vod": "VOD",
  "access-role-vod-description": "Upload videos and record livestreams",
  "access-mode-open": "Open",
  "access-mode-allowlist": "Allowlist",
  "access-mode-off": "Off",
  "access-viewer-warning": "Only accounts with the viewer role (and admins) can use this node.",
  "access-filter": "Filter by role",
  "access-filter-all": "All",
  "access-add-grant": "Grant access",
  "access-subject-placeholder": "Handle or DID",
  "access-note-placeholder": "Note (optional)",
  "access-source-environment": "From environment",
  "access-remove": "Remove",
  "access-confirm-remove": "Confirm removal",
  "access-no-grants": "No grants yet.",
  "access-policy-updated": "Policy updated",
  "access-policy-update-failed": "Failed to update policy",
  "access-grant-created": "Access granted to {$subject}",
  "access-grant-create-failed": "Failed to grant access",
  "access-grant-deleted": "Grant removed",
  "access-grant-delete-failed": "Failed to remove grant",
  "access-grants-load-failed": "Failed to load grants",
  "node-legal-documents": "Broadcaster-specific Documents",
  "backup-save": "Save backup settings",
  "backup-saving": "Saving backup settings...",
  "backup-secret-key-set-placeholder": "(Password already set)",
  "backup-error-invalid-endpoint": "Must be a valid domain name",
  "backup-error-invalid-bucket": "Must contain only lowercase letters, numbers, dots, and hyphens",
  "backup-error-invalid-segment-duration": "Must be between 1 and 60 seconds",
  "backup-error-load-failed": "Failed to load storage settings",
  "backup-error-update-failed": "Failed to update backup status",
  "backup-error-save-failed": "Failed to save storage settings",
  "backup-error-missing-secret": "Cannot update S3 settings without the secret key. Please re-enter it.",
  "backup-segment-duration-placeholder": "6",
  "badges": "Badges",
  "badges-cosmetic-section": "Cosmetic Badges",
  "badges-empty-state": "You haven't been issued any badges yet.",
  "badges-failed-load": "Failed to load badges",
  "badges-failed-update": "Failed to update badge selection",
  "badges-issued-by": "Issued by {$issuer}",
  "badges-streamer-section": "Streamer Badges",
  "issue-badges": "Issue Badges",
  "issue-badges-back-to-definitions": "Badge Definitions",
  "issue-badges-badge-name": "Badge Name",
  "issue-badges-badge-name-placeholder": "e.g. VIP, Supporter",
  "issue-badges-badge-type": "Badge Type",
  "issue-badges-choose-image": "Choose Image",
  "issue-badges-create-definition": "Create Badge Definition",
  "issue-badges-create-definition-description": "Define a new badge type that can be issued to viewers",
  "issue-badges-create-definition-subtitle": "Define a new badge type",
  "issue-badges-definition-created": "Badge definition created",
  "issue-badges-description-optional": "Description (optional)",
  "issue-badges-description-placeholder": "Optional description for this badge",
  "issue-badges-failed-create": "Failed to create badge definition",
  "issue-badges-failed-issue": "Failed to issue badge",
  "issue-badges-failed-load": "Failed to load badge definitions",
  "issue-badges-image-optional": "Image (optional)",
  "issue-badges-image-too-large": "Image must be under 256KB",
  "issue-badges-image-web-only": "Image upload is only available on web",
  "issue-badges-issue-badge": "Issue Badge",
  "issue-badges-issue-badge-description": "Issue the \"{$name}\" badge to a viewer by their DID",
  "issue-badges-issued": "Badge issued",
  "issue-badges-issued-to": "Issued to {$did}",
  "issue-badges-manage-description": "Create badge definitions and issue them to viewers",
  "issue-badges-recipient-did": "Recipient DID",
  "issue-badges-recipient-did-placeholder": "did:plc:...",
  "issue-badges-tap-to-issue": "Tap to issue",
  "issue-badges-your-definitions": "Your Badge Definitions",
  "chat-profile": "Chat Profile",
  "chat-profile-login-required": "Please log in to edit your chat profile.",
  "chat-profile-saved": "Chat profile saved",
  "chat-profile-save-failed": "Failed to save chat profile",
  "chat-profile-name-color": "Name Color",
  "chat-profile-name-color-description": "Choose the color of your name in chat.",
  "chat-profile-preview-message": "Hello, world!",
  "chat-profile-self-labels": "Self Labels",
  "chat-profile-label-bot": "Bot",
  "chat-profile-label-bot-description": "Mark your chat messages as coming from a bot.",
  "control-panel": "Control Panel",
  "create-stream-key-in-stream-settings": "Create a stream key in Stream Settings",
  "creator-settings": "Creator Settings",
  "delete-all-keys": "Delete All Keys",
  "delete-all-keys-btn": "Delete All",
  "delete-all-keys-description": "This will permanently remove all {$count} stream keys. Any streaming software configured with these keys will stop working.",
  "delete-all-keys-title": "Delete all stream keys?",
  "failed-delete-keys": "Failed to delete {$count} key(s)",
  "failed-to-delete-key": "Failed to delete key",
  "my-videos": "My Videos",
  "stream-settings": "Stream Settings",
  "stream-settings-link": "Stream Settings",
  "time-ago-days": "{$days}d ago",
  "time-ago-hours": "{$hours}h ago",
  "time-ago-minutes": "{$minutes}m ago",
  "time-ago-seconds": "{$seconds}s ago",
  "upload-videos": "Upload Videos"
}
